import axios from 'axios';

const list = (data) => axios.get('/pro/lately/list', data);
const save = (data) => axios.post('/pro/lately/save', data);
const del = (data) => axios.post('/pro/lately/delete', data);


export default {
  list,
  save,
  del,

}


